import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { api } from "../utils/api";
import i18n from "i18next";
import { LocaleManager, LocaleHelper } from "@bryntum/gantt";
import "@bryntum/gantt/locales/gantt.locale.Nl.js";
import "dayjs/locale/nl"
import dayjs from "dayjs";
import { setMuiDataGridLocale } from "./muiLocale";
import updateLocale from 'dayjs/plugin/updateLocale';

const bryntumLangMap = {
  nl: "Nl",
  en: "En",
};

const bryntumLangNameMap = {
  nl: "Dutch",
  en: "English",
};

const storeLangKey = "userLanguage";
const availableLanguages = ["en", "nl"];
// LocaleManager.throwOnMissingLocale = true; enable to what is missing translations

export function getUserLang() {
  const storedLang = localStorage.getItem(storeLangKey);
  if (storedLang) {
    return storedLang;
  }
  let bl = (navigator.language || navigator.userLanguage || "").slice(0, 2).toLowerCase();
  let lang = "en";
  if (bl) {
    lang = availableLanguages.find((lang) => bl === lang);
  }
  dayjs.locale(lang)
  return lang;
}

export function setWeekStart(startDay) {
  if (LocaleHelper.locales.Nl.DateHelper.weekStartDay != startDay) {
    LocaleHelper.locales.Nl.DateHelper.weekStartDay = startDay;
    dayjs.extend(updateLocale);
    dayjs.updateLocale('nl', { weekStart: startDay });

    if (LocaleHelper.locale.localeName == 'Nl') {
      LocaleManager.applyLocale(LocaleManager.locale.localeName, true);
    }
  }
  if (LocaleHelper.locales.En.DateHelper.weekStartDay != startDay) {
    LocaleHelper.locales.En.DateHelper.weekStartDay = startDay;
    dayjs.extend(updateLocale);
    dayjs.updateLocale('en', { weekStart: startDay });

    if (LocaleHelper.locale.localeName == 'En') {
      LocaleManager.applyLocale(LocaleManager.locale.localeName, true);
    }
  }
}

const fetchLang = createAsyncThunk("localizations/fetch", async (lang) => {
  const response = await api.get( `/localizations/${lang}.json?cacheOff=${Date.now()}`);
  const { bryntumTranslationsExtend, ...result } = await response.json();
  await i18n.addResourceBundle(lang, "translations", result, true, true);
  await i18n.changeLanguage(lang);
  dayjs.locale(lang)
  await LocaleManager.applyLocale({
    localeName: bryntumLangMap[lang],
    localeDesc: bryntumLangNameMap[lang],
    localeCode: lang,
    ...bryntumTranslationsExtend,
  });

  setMuiDataGridLocale(lang);

  localStorage.setItem(storeLangKey, lang);
  return result;
});

const i18nState = createSlice({
  name: "localizations",
  initialState: {
    lang: getUserLang(),
    translations: {
      nl: null,
      en: null,
    },
  },
  reducers: {
    changeLang: (state, action) => {
      state.lang = action.payload;
      localStorage.setItem(storeLangKey, state.lang);
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchLang.fulfilled, (state, action) => {
      state.lang = action.meta.arg;
      state.translations[state.lang] = action.payload;
    });
  },
});
export const reducer = i18nState.reducer;
export const actions = {
  changeLang: (lang) => {
    i18n.changeLanguage(lang);
    dayjs.locale(lang)
    LocaleManager.applyLocale(bryntumLangMap[lang]);
    return i18nState.actions.changeLang(lang);
  },
  fetchLang,
};

export const selectors = {
  getAll: (state) => state.i18nState,
};
